import { Action } from "../components/Actions";
import { EditorialShell } from "../components/EditorialShell";
import { RecordCollage } from "../components/RecordCollage";
import { TrackList } from "../components/TrackList";
import { ALBUMS } from "../data/albums";
import { songsByAlbum } from "../data";

interface AlbumScreenProps {
  index: number;
  selected?: string;
  onSelect(song: string): void;
  onNext(): void;
  onBack(): void;
}

export function AlbumScreen({ index, selected, onSelect, onNext, onBack }: AlbumScreenProps) {
  const album = ALBUMS[index];
  const songs = songsByAlbum.get(album.name) ?? [];
  const isLast = index === ALBUMS.length - 1;
  return (
    <EditorialShell footer={`${album.year} · ${songs.length} 首歌`} className="album-page">
      <section className="album-workspace page-enter">
        <div className="album-chapter" aria-labelledby="album-title">
          <div className="album-copy">
            <p className="section-code">第 {String(index + 1).padStart(2, "0")} 张 · 共 09 张</p>
            <h1 id="album-title">{album.name}</h1>
            <div className="album-meta"><span>{album.year}</span><span>{songs.length} 首歌</span></div>
            <p className="album-prompt">{album.prompt}</p>
          </div>
          <div className="album-artwork">
            <img src={album.cover} alt={`${album.name} 专辑封面`} />
            <RecordCollage variant="cassette" />
          </div>
        </div>
        <div className="album-track-panel">
          <div className="tracklist-heading"><div><span>从这一张里</span><h2>选一首歌</h2><p>选你最喜欢的，或最能代表自己的。</p></div><span>{selected ? `已选择 · ${selected}` : "尚未选择"}</span></div>
          <TrackList songs={songs} selected={selected} cover={album.cover} onSelect={onSelect} />
          <div className="album-actions">
            <Action tone="secondary" onClick={onBack}>上一步</Action>
            <Action onClick={onNext} disabled={!selected}>{isLast ? "查看九首选择" : "下一张专辑"}</Action>
          </div>
        </div>
      </section>
    </EditorialShell>
  );
}
